import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Button,
  Center,
  Flex,
  Heading,
  IconButton,
  Skeleton,
  TabList,
  Text,
  TabPanel,
  TabPanels,
  Tabs,
  useMediaQuery,
  Input,
  FlexProps
} from '@chakra-ui/react'
import { SelectCheckboxMenu } from 'components'

import React from 'react'
import { VscSearch, VscAdd } from 'react-icons/vsc'

import { StyledTab } from 'styles'

type SearchLoaderProps = {
  showDescription?: boolean
} & FlexProps

const SearchLoader: React.FC<SearchLoaderProps> = ({ showDescription, ...rest }) => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <Flex
      position="relative"
      pt={6}
      direction="column"
      justify={['flex-start', 'flex-start', 'center']}
      {...rest}
      width="100%"
    >
      {showDescription && (
        <Skeleton my={6} maxW="fit-content">
          <Heading
            as="h3"
            fontSize={['4xl', '5xl']}
            textAlign={isTabletOrMobile ? 'center' : 'left'}
            fontWeight="normal"
          >
            Propriété à louer à kinshasa
          </Heading>
        </Skeleton>
      )}
      <Tabs>
        <TabList borderBottomColor="transparent">
          {Array.from(Array(3).keys()).map((i) => (
            <Skeleton mr={1} key={i} maxW="fit-content">
              <StyledTab>Nsoko.com</StyledTab>
            </Skeleton>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel w="100%" px={0}>
            <Skeleton>
              <Flex
                border="1px solid"
                align={isTabletOrMobile ? 'flex-end' : 'center'}
                borderRadius="md"
                mb={4}
                position="relative"
              >
                <Flex
                  align="center"
                  direction={isTabletOrMobile ? 'column' : 'row'}
                  mx={3}
                  flex={1}
                >
                  <Input
                    variant="unstyled"
                    fontSize="sm"
                    position="relative"
                    px={2}
                    name="search"
                    py={isTabletOrMobile ? 2 : 5}
                    placeholder="Rechercher une ville ou un quartier ..."
                  />
                </Flex>
                <Center position="relative">
                  <IconButton
                    size="md"
                    type="submit"
                    borderRadius="0 md md 0"
                    aria-label="Change Theme"
                    icon={<VscSearch />}
                  />
                </Center>
              </Flex>
            </Skeleton>
            <Flex
              flexWrap="wrap"
              display={isTabletOrMobile ? 'grid' : 'flex'}
              gridTemplateColumns="repeat(2, 1fr)"
              gridColumnGap={3}
              align="flex-end"
            >
              {Array.from(Array(5).keys()).map((i) => (
                <SelectCheckboxMenu
                  key={i}
                  isLoaded={false}
                  label="Type de propriété"
                  title="Propriété"
                  mr={isTabletOrMobile ? 0 : undefined}
                  gridColumn={i === 0 && isTabletOrMobile ? 'span 2' : undefined}
                />
              ))}

              <Accordion
                allowMultiple
                width="100%"
                gridColumn={isTabletOrMobile ? 'span 2' : undefined}
                my={6}
              >
                <AccordionItem border="none">
                  <AccordionButton as={Button} width={isTabletOrMobile ? '100%' : 'auto'}>
                    <Skeleton>
                      <Text fontWeight="normal" fontSize="sm" mr={2}>
                        Plus de filtres
                      </Text>
                      <VscAdd />
                    </Skeleton>
                  </AccordionButton>
                </AccordionItem>
              </Accordion>
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  )
}

SearchLoader.defaultProps = {
  showDescription: true
}

export default SearchLoader
